<template>
	<section>

		<!--列表-->
		<el-table stripe :data="discounts" highlight-current-row v-loading="firstLoading" style="width: 100%;">
			<el-table-column prop="doctorName" label="Doctor" >
			</el-table-column>
			<el-table-column prop="storageFreeDuration" label="Free duration (Month)"  >
			</el-table-column>
			<el-table-column prop="discountRate" label="Discount rate">
			</el-table-column>
			<el-table-column prop="storageFeeOverDays" label="Storage Fee Over days">
			</el-table-column>
			<el-table-column label="Action">
                <template slot-scope="scope">
                    <el-button size="small" @click="showEdit(scope.row)">Edit</el-button>
                </template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handlePageChange" :page-size="pageSize" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

        <el-dialog title="Edit Discount" width="80%" :visible.sync="editVisible" :close-on-click-modal="false">
            <el-form :model="editDiscount" label-width="220px" :rules="formRules" ref="editDiscount">
                <el-form-item label="Doctor Name" prop="doctorName">
                    <el-input v-model="editDiscount.doctorName" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Storage Free Duration (Month)" prop="storageFreeDuration">
                    <el-input-number v-model="editDiscount.storageFreeDuration" :min="3"></el-input-number>
                </el-form-item>
                <el-form-item label="Discount Rate" prop="discountRate">
                    <el-input-number v-model="editDiscount.discountRate" :precision="2" :step="0.05" :min="0.01" :max="1.0"></el-input-number>
                </el-form-item>
                <el-form-item label="Storage Fee Over days" prop="storageFeeOverDays">
                    <el-input-number v-model="editDiscount.storageFeeOverDays" :precision="0" :step="1" :min="0"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editVisible = false;getDiscounts();">Close</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">Submit</el-button>
            </div>
        </el-dialog>

	</section>
</template>


<script>
    import util from '../../common/js/util'
    import {defaultPageSize} from "../../globalVar";
    import {editDiscount, getDiscountList} from "../../api/discountService";

    export default {
        data() {
            return {
                firstLoading: false,
                pageSize:defaultPageSize,

                activeName:"first",

                filters: {
                    email: ''
                },

                discounts: [],

                total:0,
                page:1,


                editVisible: false,//编辑界面是否显示

                editLoading: false,
                editFormRules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ]
                },
                //编辑界面数据
                editDiscount: {
                    userNo: "",
                    doctorNo: "",
                    doctorName:"",
                    storageFreeDuration: 3,
                    discountRate: 1.00,
                    storageFeeOverDays: undefined,
                    id:null
                },

                addFormVisible: false,//新增界面是否显示
                addLoading: false,
                formRules: {
                    storageFreeDuration: [
                        { required: true, message: 'Storage Free Duration is required.', trigger: 'blur' }
                    ],
                    discountRate:[
                        { required: true, message: 'Discount Rate is required.', trigger: 'blur' }
                    ]
                }

            }
        },
        methods: {
            handlePageChange(val) {
                this.page = val;
                this.getDiscounts();
            },
            showEdit(row){
                this.editDiscount = row;
                this.editVisible = true;
            },
            editSubmit(){
                this.editLoading = true;
                let para = {
                    userNo: this.editDiscount.userNo,
                    doctorNo: this.editDiscount.doctorNo,
                    doctorName:this.editDiscount.doctorName,
                    storageFreeDuration: this.editDiscount.storageFreeDuration,
                    discountRate: this.editDiscount.discountRate,
                    storageFeeOverDays: this.editDiscount.storageFeeOverDays,
                    id:this.editDiscount.id
                };
                editDiscount(para).then((res)=>{
                    this.editLoading = false;
                    if(res.status===200){
                        this.$message({
                            message:res.message,
                            type:"success"
                        });
                        this.getDiscounts();
                        this.editVisible = false;
                    }else{
                        this.$message({
                            message:res.message,
                            type:"error"
                        })
                    }
                })
            },
            getDiscounts(){
                let para = {
                    current: this.page,
                    size:this.pageSize
                };

                this.firstLoading = true;
                getDiscountList(para).then(res=>{
                    this.firstLoading = false;
                    if(res.status===200){
                        this.discounts = res.result.records;
                        this.total = res.result.total;
                    }else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
        },
        mounted() {
            this.getDiscounts();
        }
    }

</script>


// WEBPACK FOOTER //
// discounts.vue?92eb87f8